import qs from 'qs'
import store from './index'
const cusapi = 'cusapi'
const api = 'webapi'
const BaseUrl = process.env.VUE_APP_BASE_URL + '/'
export const get = async (url, data) => {
  try {
    const params = {
      method: 'GET'
    }
    if (data) {
      params.data = qs.stringify(data)
    }
    store.commit('setFetching', true)
    const ret = await fetch(`${BaseUrl}${url}`, params)
    const result = await ret.json()
    store.commit('setFetching', false)
    return result
  } catch (error) {
    store.commit('setFetching', false)
    return false
  }
}
export const getapi = async (url, data, setFetching = true) => {
  try {
    const params = {
      method: 'GET'
    }
    if (data) {
      params.data = qs.stringify(data)
    }
    if (setFetching) store.commit('setFetching', true)
    const ret = await fetch(`${BaseUrl}${api}/${url}`, params)
    const result = await ret.json()
    if (setFetching) store.commit('setFetching', false)
    return result
  } catch (error) {
    if (setFetching) store.commit('setFetching', false)
    return false
  }
}
export const getapi2 = async (url, data) => {
  try {
    const params = {
      method: 'GET'
    }
    if (data) {
      params.data = qs.stringify(data)
    }
    const ret = await fetch(`${BaseUrl}${api}/${url}`, params)
    const result = await ret.json()
    return result
  } catch (error) {
    store.commit('setFetching', false)
    return false
  }
}
export const getcusapi = async (url, data) => {
  try {
    const params = {
      method: 'GET'
    }
    if (data) {
      params.data = qs.stringify(data)
    }
    store.commit('setFetching', true)
    const ret = await fetch(`${BaseUrl}${cusapi}/${url}`, params)
    const result = await ret.json()
    store.commit('setFetching', false)
    return result
  } catch (error) {
    store.commit('setFetching', false)
    return false
  }
}
export const post = async (url, body) => {
  try {
    const params = {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    }
    if (body) {
      params.body = JSON.stringify(body)
    }
    // console.log(BaseUrl, !!BaseUrl, location.pathname, `${BaseUrl}${url}`, params)
    const ret = await fetch(`${BaseUrl}${url}`, params)
    // console.log(ret, 'ret')
    const result = await ret.json()
    return result
  } catch (error) {
    // console.log('login error', error)
    return false
  }
}
export const postcusapi = async (url, body) => {
  try {
    const params = {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    }
    if (body) {
      params.body = JSON.stringify(body)
    }
    store.commit('setFetching', true)
    const ret = await fetch(`${BaseUrl}${cusapi}/${url}`, params)
    const result = await ret.json()
    store.commit('setFetching', false)
    return result
  } catch (error) {
    store.commit('setFetching', false)
    return false
  }
}
export const postapi = async (url, body, setFetching) => {
  try {
    const params = {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    }
    if (body) {
      params.body = JSON.stringify(body)
    }
    if (setFetching) store.commit('setFetching', true)
    const ret = await fetch(`${BaseUrl}${api}/${url}`, params)
    const result = await ret.json()
    if (setFetching) store.commit('setFetching', false)
    return result
  } catch (error) {
    if (setFetching) store.commit('setFetching', false)
    return false
  }
}
export const postapi2 = async (url, body) => {
  try {
    const params = {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    }
    if (body) {
      params.body = JSON.stringify(body)
    }
    const ret = await fetch(`${BaseUrl}${api}/${url}`, params)
    const result = await ret.json()
    return result
  } catch (error) {
    store.commit('setFetching', false)
    return false
  }
}

export const putapi = async (url, body) => {
  try {
    const params = {
      method: 'PUT',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    }
    if (body) {
      params.body = JSON.stringify(body)
    }
    const ret = await fetch(`${BaseUrl}${api}/${url}`, params)
    const result = await ret.json()
    return result
  } catch (error) {
    return false
  }
}
export const putapi1 = async (url, body) => {
  try {
    const params = {
      method: 'PUT',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    }
    if (body) {
      params.body = JSON.stringify(body)
    }
    const ret = await fetch(`${BaseUrl}${api}/${url}`, params)
    const result = await ret.json()
    return result
  } catch (error) {
    return false
  }
}
export const put = async (url, body) => {
  try {
    const params = {
      method: 'PUT',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    }
    if (body) {
      params.body = JSON.stringify(body)
    }
    const ret = await fetch(`${BaseUrl}/${url}`, params)
    const result = await ret.json()
    return result
  } catch (error) {
    return false
  }
}

export const del1 = async (url) => {
  try {
    const params = {
      method: 'DELETE',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    }
    store.commit('setFetching', true)
    const ret = await fetch(`${BaseUrl}/${url}`, params)
    const result = await ret.json()
    store.commit('setFetching', false)
    return result
  } catch (error) {
    store.commit('setFetching', false)
    return false
  }
}
export const deleteapi = async (url) => {
  try {
    const params = {
      method: 'DELETE',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    }
    store.commit('setFetching', true)
    const ret = await fetch(`${BaseUrl}${api}/${url}`, params)
    const result = await ret.json()
    store.commit('setFetching', false)
    return result
  } catch (error) {
    store.commit('setFetching', false)
    return false
  }
}
export const uploadimage = async (event, url) => {
  try {
    const img = new FormData()
    img.append('image', event.target.files[0])
    const params = {
      method: 'PUT',
      body: img
    }
    store.commit('setFetching', true)
    const ret = await fetch(`${BaseUrl}${api}/images/${url}`, params)
    const result = await ret.json()
    store.commit('setFetching', false)
    return result
  } catch (error) {
    store.commit('setFetching', false)
    return false
  }
}
export const uploadother = async (event, url) => {
  try {
    const file = new FormData()
    file.append('file', event.target.files[0])
    const params = {
      method: 'PUT',
      body: file
    }
    store.commit('setFetching', true)
    const ret = await fetch(`${BaseUrl}${api}/audios/${url}`, params)
    const result = await ret.json()
    store.commit('setFetching', false)
    return result
  } catch (error) {
    store.commit('setFetching', false)
    return false
  }
}
export const downloadimage = async (url) => {
  const params = {
    responseType: 'blob'
  }
  try {
    const ret = await fetch(`${BaseUrl}${url}`, params)
    const blobResponse = await ret.blob()
    // console.log(blobResponse)
    var fileURL = window.URL.createObjectURL(blobResponse)
    var fileLink = document.createElement('a')
    fileLink.href = fileURL
    fileLink.setAttribute('download', url)
    document.body.appendChild(fileLink)
    fileLink.click()
    return true
  } catch (error) {
    store.commit('setFetching', false)
    return false
  }
}
